import { searchMedications } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type {
  MedicationSearchResultT,
  SearchMedicationsParams,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function fetchSearchMedications(
  params: SearchMedicationsParams,
  signal?: AbortSignal
): Promise<MedicationSearchResultT[]> {
  const config = await createLotusRequestConfig({ signal });
  const response = await searchMedications(params, config);
  return lotusHealthZod.searchMedicationsResponse.parse(response.data) as MedicationSearchResultT[];
}
